import axios from 'axios';

export const api = axios;
api.defaults.baseURL = process.env.NEXT_PUBLIC_API_URL;
api.defaults.withCredentials = true;
